import * as React from "react";

export const Switch = React.forwardRef(
  (
    {
      className = "",
      checked,
      defaultChecked,
      onCheckedChange,
      disabled = false,
      id,
      ...props
    },
    ref
  ) => {
    return (
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        id={id}
        ref={ref}
        disabled={disabled}
        tabIndex={0}
        className={
          "relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none " +
          (checked
            ? "bg-blue-600"
            : "bg-gray-200") +
          (disabled ? " opacity-50 cursor-not-allowed" : "") +
          " " +
          className
        }
        onClick={e => {
          if (disabled) return;
          onCheckedChange && onCheckedChange(!checked);
        }}
        {...props}
      >
        <span
          className={
            "inline-block h-4 w-4 transform rounded-full bg-white transition-transform shadow " +
            (checked ? "translate-x-5" : "translate-x-1")
          }
        />
      </button>
    );
  }
);

Switch.displayName = "Switch";
